module.exports = __webpack_public_path__ + "static/media/eurobianco.26daf28e.svg";